// extracted by mini-css-extract-plugin
export var active = "_ab-a";
export var activeIndicator = "_ab-8";
export var animate = "_ab-9";
export var disabled = "_ab-b";
export var fullWidth = "_ab-2";
export var lg = "_ab-7";
export var md = "_ab-6";
export var redoButtonTabGroup = "_ab-0";
export var sm = "_ab-5";
export var tabButton = "_ab-3";
export var tabButtonsContainer = "_ab-1";
export var xs = "_ab-4";